export default __webpack_public_path__ + "static/media/PS_outline.8e83270a.png";